import { render } from "./GuideSize.vue?vue&type=template&id=16d71c3a&scoped=true"
import script from "./GuideSize.vue?vue&type=script&lang=js"
export * from "./GuideSize.vue?vue&type=script&lang=js"

import "./GuideSize.vue?vue&type=style&index=0&id=16d71c3a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d71c3a"]])

export default __exports__